import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'
import palette from '../../../styles/palette'

/**
 * Rodapé do mockup Lovable: faixa lavanda clara, colunas com título em
 * caixa alta e corpo em texto secundário.
 */
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      marginTop: 40,
      backgroundColor: colors.lilac,
    },
    boxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '90%',
      paddingTop: 24,
      paddingBottom: 24,
      paddingRight: 40,
      [theme.breakpoints.up('xl')]: {
        maxWidth: '100%',
      },
      [theme.breakpoints.between('md', 'lg')]: {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    /** Título de coluna: caixa alta, peso 600, cor de texto principal. */
    titleFooter: {
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      color: palette.text,
      marginBottom: 4,
    },
    textFooter: {
      fontSize: '0.75rem',
      color: colors.grayMedium,
    },
    boxIconMedia: {
      display: 'flex',
      gap: 12,
      alignItems: 'center',
      marginTop: 8,
      [theme.breakpoints.down('xs')]: {
        width: '100px',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        width: '100px',
      },
    },
  }),
)
